import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../../icon-button';

const ClearButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps: { ref, onMouseDown, ...restInnerProps },
  } = props;

  return (
    <div {...restInnerProps} ref={ref} className="ws-ui-tag-input__clear-button">
      <IconButton
        disabled={isDisabled}
        onMouseDown={onMouseDown}
        glyph="clear-search"
        size="medium"
      />
    </div>
  );
};

ClearButton.propTypes = {
  clearValue: PropTypes.func.isRequired,
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool.isRequired,
  }).isRequired,
  innerProps: PropTypes.shape({
    ref: PropTypes.any,
    onMouseDown: PropTypes.func,
  }).isRequired,
};

export default ClearButton;
